import { fetchBaseQuery } from "@reduxjs/toolkit/query";
import { setUser } from "./slices/user";

export const API_BASE_URL = 'https://masjidhub.org';

export const createCustomFetchBaseQuery = () => {
  const baseQuery = fetchBaseQuery({
    baseUrl: API_BASE_URL,
    prepareHeaders: (headers, { getState }) => {
      const state = getState();
      let { user } = state.Auth || {}; // Safely access Auth slice

      // console.log("User from Auth slice (raw):", user);

      // Parse the user if it's stored as a JSON string
      if (typeof user === "string") {
        try {
          user = JSON.parse(user); // Parse the user object
        } catch (error) {
          console.error("Failed to parse user JSON:", error);
        }
      }

      // console.log("Parsed User from Auth slice:", user);

      if (user && user.accessToken) {
        headers.set('Authorization', `${user.accessToken}`);
      }

      return headers;
    },
  });

  return async (args, api, extraOptions) => {
    let result = await baseQuery(args, api, extraOptions);

    // An expired, invalid or suspended session: sign out, which sends the
    // user back to the login page. Login failures are 401s too, but there is
    // no session to clear then.
    if (result.error && result.error.status === 401 && api.getState().Auth?.user) {
      api.dispatch(setUser(null));
    }

    return result;
  };
};
